var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-play_1",
    "data-name": "google-play 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28.192 30.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.385,14.689,1.131,29.378A2.6,2.6,0,0,1,0,27.212V2.165A2.6,2.6,0,0,1,1.131,0Z",
    transform: "translate(0 0.502)",
    fill: "#2196f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M20.592,10.06l-5.338,5.131L0,.5A2.033,2.033,0,0,1,.179.378,2.61,2.61,0,0,1,2.814.337Z",
    transform: "translate(1.131 0)",
    fill: "#4caf50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M11.806,5.131a2.637,2.637,0,0,1-1.379,2.345L5.338,10.261,0,5.131,5.338,0l5.089,2.786A2.637,2.637,0,0,1,11.806,5.131Z",
    transform: "translate(16.385 10.06)",
    fill: "#f0bb1f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M20.592,5.131,2.814,14.854a2.644,2.644,0,0,1-2.634-.041A2.034,2.034,0,0,1,0,14.689L15.254,0Z",
    transform: "translate(1.131 15.191)",
    fill: "#f15a2b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.0b67b69062a64e95ee7def5876f07471.svg";
export { ForwardRef as ReactComponent };